import { render } from "./WinModal.vue?vue&type=template&id=0b6ecdf7"
import script from "./WinModal.vue?vue&type=script&lang=js"
export * from "./WinModal.vue?vue&type=script&lang=js"

import "./WinModal.vue?vue&type=style&index=0&id=0b6ecdf7&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__